import React from "react";
import { Button } from "@/components/ui/Button";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

const NotFoundPage = () => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        if (typeof window !== "undefined" && window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("/dashboard");
        }
    };

    return (
        <>
            <div className="text-center">
                <div className="">
                    <p className="mb-6 font-bold text-red-500 text-7xl sm:text-8xl slide-up">404</p>
                    <p className="mb-6 text-sm text-gray-300 sm:text-base slide-up">
                        The page you are looking for does not exist or has been moved..
                    </p>
                    <p className="mb-6 text-sm text-gray-300 sm:text-base slide-up">
                        Please click on the dashboard button to go to the dashboard
                    </p>
                </div>
                <div className="text-center">
                    <Button
                        className="w-full hover:bg-red-900 sm:w-auto rounded-md"
                        onClick={() => navigate("/")}
                    >
                        Dashboard
                    </Button>
                </div>
            </div>

        </>
    );
};

export default NotFoundPage;

